import { useState } from "react";
import dayjs from "@shared/dayjs";
import { CheckboxOption, CheckboxGroupHeading } from "@shared/v2/Dropdown/custom/MultiComponents";
import Button from "@shared/v2/Button";
import DatePicker from "@shared/v2/DatePicker";
import Dropdown from "@shared/v2/Dropdown";
import LogFilters from "./LogFilters";

const ReportsFilters = ({
  selectedTrackingNumbers,
  trackingNumbers,
  handleTrackingNumberFilterOnChange,
  minDate,
  maxDate,
  setMinDate,
  setMaxDate,
  chosenView,
  logFilters,
  setLogFilters,
  agents,
  selectedLog,
  isDisabled,
}) => {
  const [filtersVisible, setFiltersVisible] = useState(false);

  const applyFilters = (filters) => {
    setLogFilters(filters);
    setFiltersVisible(false);
  };
  const CustomCheckboxGroupHeading = (props) => {
    return (
      <>
        <CheckboxGroupHeading {...props} className="!tw-text-[14px] !tw-bg-white !tw-font-normal" />
        <hr className="tw-m-0 tw-border-gray-10" />
      </>
    );
  };
  return (
    <div className="tw-flex tw-flex-wrap tw-justify-between tw-gap-[16px] tw-bg-white tw-rounded-[8px] tw-border-solid tw-border-[1px] tw-border-neutral-gray-10 bs-xs:tw-p-[15px] tw-pl-[32px] tw-pr-20px tw-py-20px">
      <span className="tw-flex tw-text-gray-75 tw-m-0 tw-whitespace-nowrap tw-text-28px">
        Tracking Number {chosenView === "logs" ? "Logs" : "Reporting"}
      </span>
      <div className="tw-flex tw-gap-[16px] tw-flex-wrap">
        <div className="tw-w-[264px]">
          <Dropdown
            placeholder={
              selectedTrackingNumbers.length === 0 ||
              selectedTrackingNumbers.length === trackingNumbers.length
                ? "All Tracking Numbers"
                : `${selectedTrackingNumbers.length} number${selectedTrackingNumbers.length === 1 ? "" : "s"} selected`
            }
            isMulti
            value={selectedTrackingNumbers}
            options={[{ label: "All Tracking Numbers", options: trackingNumbers }]}
            onChange={handleTrackingNumberFilterOnChange}
            menuShouldComeToFront
            closeMenuOnSelect={false}
            blurInputOnSelect={false}
            multiShouldRenderBelowSelect={false}
            hideSelectedOptions={false}
            controlShouldRenderValue={false}
            components={{ GroupHeading: CustomCheckboxGroupHeading, Option: CheckboxOption }}
            isSearchable
          />
        </div>
        <DatePicker
          value={dayjs(minDate).format("MM/DD/YYYY")}
          onChange={(value) => {
            const parsed = dayjs(value, "MM/DD/YYYY", true);
            setMinDate(parsed.isValid() ? parsed.format("YYYY-MM-DD") : null);
          }}
          inputProps={{ size: 10, placeholder: "Min Date" }}
          position="bottom"
        />
        <DatePicker
          value={dayjs(maxDate).format("MM/DD/YYYY")}
          onChange={(value) => {
            const parsed = dayjs(value, "MM/DD/YYYY", true);
            setMaxDate(parsed.isValid() ? parsed.format("YYYY-MM-DD") : null);
          }}
          inputProps={{ size: 10, placeholder: "Max Date" }}
          position="bottom"
        />
        {chosenView === "logs" && selectedLog !== "texts" && (
          <Button
            disabled={isDisabled}
            schema="secondary"
            size="medium"
            onClick={() => setFiltersVisible(true)}
          >
            Filters
          </Button>
        )}
      </div>
      {filtersVisible && (
        <LogFilters
          filters={logFilters}
          onApply={applyFilters}
          onClose={() => setFiltersVisible(false)}
          agents={agents}
        />
      )}
    </div>
  );
};

export default ReportsFilters;
